"use client"

import { Toaster } from "@/components/ui/sonner"

interface ToastProviderProps {
  children: React.ReactNode
}

/**
 * Toast Provider with shadcn sonner
 * Uses Nova design tokens via CSS variables
 * Position: top-right globally
 */
export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster position="top-right" closeButton richColors />
    </>
  )
}
